import React from "react";

import { Box } from "@material-ui/core";

const TextLabel = ({ label, value, center, labelStyle, valueStyle }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems={center ? "center" : "flex-start"}
    >
      <span className={labelStyle}>{label && label}</span>
      <span className={valueStyle}>{value && value}</span>
    </Box>
  );
};

export default TextLabel;
